import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { FilterOptionsGroup } from '../../index';

export class FilterOptionsGroupDynamic extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: props.dataSource,
    };
  }

  onRemove = (selectedItems) => {
    const { dataSource } = this.state;
    const lastSelected = _.last(selectedItems);
    if (lastSelected.HasChild) {
      this.setState({ dataSource: dataSource.slice(0, -1) });
    }
  }

  onAdd = (selectedItems) => {
    const { dataSource } = this.state;
    const selectedItem = _.last(selectedItems);
    const id = _.result(selectedItem, 'id');
    const dataSourceItem = _.find(dataSource, i => i.Text === id);
    const attribute = _.result(_.result(selectedItem, 'data'), 'value');
    const operand = _.result(dataSourceItem, 'Value');

    if (dataSourceItem.HasChild) {
      this.props.getChildProductCondition(attribute, operand).then((dynamicOption) => {
        const dynamicValue = _.result(dynamicOption, 'Value');
        if (!_.isEmpty(dynamicValue)
          && _.isUndefined(_.find(dataSource, i => i.Value === dynamicValue))) {
          this.setState({ dataSource: dataSource.concat(_.extend(dynamicOption)) });
        } else {
          dataSourceItem.HasChild = false;
        }
      });
    }
  }

  render() {
    return (
      <FilterOptionsGroup
        {..._.omit(this.props, 'dataSource')}
        dataSource={this.state.dataSource}
        onAddFilterOptionsItemCallback={this.onAdd}
        onRemoveFilterOptionsItemCallback={this.onRemove}
      />
    );
  }
}

FilterOptionsGroupDynamic.propTypes = {
  getChildProductCondition: PropTypes.func.isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.shape({
    Text: PropTypes.string.isRequired,
    Value: PropTypes.string.isRequired,
    ValueOptions: PropTypes.arrayOf(PropTypes.shape({
      Selected: PropTypes.bool.isRequired,
      Text: PropTypes.string.isRequired,
      Value: PropTypes.string.isRequired,
    })),
  })).isRequired,
};
